export const SAFE_HTTP_ERROR_MESSAGES: Readonly<Partial<Record<number, string>>> = {
  400: "Некорректный запрос. Проверьте введённые данные",
  401: "Требуется авторизация",
  403: "Доступ запрещён",
  404: "Запрашиваемые данные не найдены",
  409: "Данные конфликтуют с уже существующей записью",
  429: "Слишком много запросов. Попробуйте немного позже",
  500: "Сервер временно недоступен. Попробуйте ещё раз",
  502: "Сервер временно недоступен. Попробуйте ещё раз",
  503: "Сервер временно недоступен. Попробуйте ещё раз",
};
